// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";
import { AnyAction } from "@insite/client-framework/Store/Reducers";
import {
    getProductInformationDocuments as getDocumentsApi,
    ProductInformationDocumentsApiParameters,
    ProductInformationDocumentsModel,
} from "@stoneage/App/Services/Documents/DocumentsService";

interface Props {
    apiParameter: ProductInformationDocumentsApiParameters;
    apiResult: {
        successful: boolean;
        data: ProductInformationDocumentsModel | undefined;
    };
}

type Parameter = {
    onSuccess?: (result: any) => void;
    onError?: (e: any) => void;
    apiParameters: ProductInformationDocumentsApiParameters;
};

type HandlerType = Handler<Parameter, Props>;

export const BeginLoadingProducts: HandlerType = props => {
    props.dispatch({ type: "Pages/ProductInformation/BeginLoadingDocuments" } as unknown as AnyAction);
};

export const PopulateApiParameters: HandlerType = props => {
    props.apiParameter = { ...props.parameter.apiParameters };
};

export const RequestDataFromApi: HandlerType = async props => {
    props.apiResult = await getDocumentsApi(props.apiParameter);
};

export const onSuccess: HandlerType = props => {
    props.dispatch({
        type: "Pages/ProductInformation/AssignDocumentsToData",
        data: props.apiResult.data,
    } as unknown as AnyAction);
    if (props.apiResult && props.apiResult.successful) {
        props.parameter.onSuccess?.(props.apiResult);
    }
};

export const OnError: HandlerType = props => {
    props.dispatch({ type: "Pages/ProductInformation/CompletedLoadingDocuments" } as unknown as AnyAction);
    if (props.apiResult && !props.apiResult.successful) {
        props.parameter.onError?.(props.apiResult);
    }
};

export const chain = [BeginLoadingProducts, PopulateApiParameters, RequestDataFromApi, onSuccess, OnError];

const getProductInformationDocuments = createHandlerChainRunner(chain, "GetProductInformationDocuments");
export default getProductInformationDocuments;
